import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  Button,
  CardActions,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import { useNavigate } from "react-router-dom";

const OrderOverviewCard = ({ orders }) => {
  const navigate = useNavigate();

  useEffect(() => {}, [orders]);

  const handleNavigateDetails = () => {
    navigate("/order");
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: 200,
        minHeight: 350,
        maxHeight: 350,
      }}
    >
      <CardContent>
        <Stack spacing={1} direction="row" sx={{ alignItems: "center", mb: 1 }}>
          <FastfoodIcon />
          <Typography variant="h6" color="primary" sx={{ mr: 1 }} gutterBottom>
            Open Orders
          </Typography>
        </Stack>

        <Divider />
        <TableContainer>
          <Table>
            {orders && (
              <TableBody>
                {orders.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell>
                      <Typography sx={{ fontSize: 16, mr: 1 }}>
                        {order.name}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={handleNavigateDetails}>
          Details
        </Button>
      </CardActions>
    </Card>
  );
};

export default OrderOverviewCard;
